<template>
  <v-dialog v-model="open" width="100%" max-width="500px" persistent>
    <v-card>
      <v-card-title class="dialog-title bold"> بروز رسانی برنامه </v-card-title>

      <v-divider />

      <v-card-text class="dialog-content mt-2">
        نسخه جدیدی از وب‌اپ یافت شد ! لطفا بروز رسانی کنید
      </v-card-text>

      <v-card-actions>
        <v-btn
          large
          block
          color="#1565C0"
          elevation="0"
          style="color: #ffffff; font-size: 14px"
          class="bold"
          :loading="loading"
          @click.prevent="update"
        >
          بروز رسانی
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "UpdateDialog",
  props: {
    open: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return { loading: false };
  },
  methods: {
    update() {
      this.loading = true;
      window.location.reload(true);
    },
  },
};
</script>

<style scoped>
div >>> .v-dialog {
  border-radius: 8px !important;
}
.dialog-title {
  font-size: 16px !important;
  color: #020202 !important;
  letter-spacing: 0 !important;
}
.dialog-content {
  color: #404040 !important;
  font-size: 12px !important;
}
</style>
